import React from "react";
import RghtnowMarketingHeader from "./RghtnowMarketingHeader";
import RghtnowMarketingFooter from "./RghtnowMarketingFooter";
import "./rghtnow-pages.css";
import "./legal-pages.css";

const termsSections = [
  {
    title: "Terms and Conditions Preamble",
    blocks: [
      {
        text: [
          "Welcome to RGHTNOW.com. RGHT NOW LLC-FZ provides this website and mobile application as a service to our clients.",
          "By using the website or mobile application, you accept these Terms and Conditions and agree to be bound by them.",
          "These Terms and Conditions may change at any time. Any updates posted on the website or mobile application become effective immediately.",
          "Every time you use the website or app, it is your responsibility to read the latest Terms and Conditions.",
          "Use of the website or app is not permitted if you disagree with, or are unable to comply with, any part of these Terms and Conditions.",
          "All information provided by you must be accurate and factual. By confirming your order at checkout, you agree to accept and pay for the requested item(s).",
        ],
      },
      {
        heading: "Cancellation",
        text: [
          "We reserve the right to refuse or cancel any order at our sole discretion. Orders may be cancelled due to quantity limits, inaccurate pricing or product information, payment issues, or verification requirements.",
          "If an order is cancelled after your credit card has been charged, the appropriate amount will be credited back to your card.",
        ],
      },
    ],
  },
  {
    title: "Website & App Security",
    blocks: [
      {
        text: [
          "You are prohibited from violating the security of the website or app, including accessing data that is not intended for you, testing system exposure without authorization, interfering with service, or sending unsolicited promotional email.",
          "Security violations may lead to legal or criminal responsibility. We may investigate and cooperate with prosecution where required.",
          "You agree not to use tools, programs, software, spiders, robots, avatars, or intelligent agents to disrupt, scrape, navigate, or search the website or app without authorization.",
        ],
      },
      {
        heading: "Terms of Use",
        text: [
          "Only people who are legally able to enter into contracts under applicable law may use the website or app.",
          "If you are under 18 and are a registered user or member, your parent or legal guardian may transact on your behalf. We may cancel registrations and deny access where legal capacity requirements are not met.",
        ],
      },
      {
        heading: "Registration Process",
        text: [
          "Your information will be safeguarded in accordance with our Privacy Policy. You are responsible for maintaining the confidentiality of your account and password.",
          "Any unusual activity or suspected breach must be reported immediately. We may ask you to change your password or suspend your account if misuse is suspected.",
        ],
      },
    ],
  },
  {
    title: "Product's Pricing",
    blocks: [
      {
        text: [
          "Product and pricing information may occasionally contain errors or inaccuracies. Product prices are confirmed only after an order is placed.",
          "If a product is listed at an incorrect price or with inaccurate details, we may contact you for instructions or cancel the order and notify you.",
          "All prices, product availability, descriptions, specifications, and in-store or online price variations are subject to change without prior notice.",
        ],
      },
    ],
  },
  {
    title: "Redeeming a coupon from rghtnow.com (Where Applicable)",
    blocks: [
      {
        heading: "Order Acceptance",
        text: [
          "If a coupon is permitted through the website or app, the discount may only be used as allowed by the applicable offer conditions.",
          "We reserve the right to refuse or cancel orders due to quantity limits, pricing errors, product information errors, or credit and fraud checks.",
        ],
      },
      {
        heading: "Cancellations by the Customer",
        text: [
          "If we receive your cancellation request before an order is processed or approved, we will cancel the order and refund the eligible amount.",
          "Orders cancelled after shipment may be subject to shipping, processing, or cancellation fees as applicable.",
        ],
      },
      {
        heading: "Quantity Limits and Merchant and Dealer Sales",
        text: [
          "We reserve the right to limit quantities purchased per person, household, account, card, device, billing address, or shipping address.",
        ],
      },
    ],
  },
  {
    title: "Credit/Debit Card Information",
    blocks: [
      {
        text: [
          "We accept online payments in AED or other agreed currencies using accepted Visa and MasterCard credit or debit cards.",
          "Credit/debit card details and personally identifiable information are not stored, sold, shared, rented, or leased to third parties.",
          "You confirm that any card details provided by you are truthful, valid, accurate, and lawfully used by you.",
        ],
      },
      {
        heading: "Unlawful Transactions",
        text: [
          "We reserve the right to recover product costs, collection charges, and legal fees from anyone using the website or app fraudulently.",
        ],
      },
      {
        heading: "E-Communications",
        text: [
          "When you visit the website, use the app, or send emails to us, you communicate electronically and agree to receive electronic communications from us.",
        ],
      },
    ],
  },
  {
    title: "Shipping, Substitute and Amendments",
    blocks: [
      {
        heading: "Shipping",
        text: [
          "Shipping charges may vary based on product weight, size, destination, order value, and shipping strategy. Delivery may be handled by courier, supplier, merchant, or business partner.",
        ],
      },
      {
        heading: "Substitute",
        text: [
          "If an item is unavailable while picking an order, an alternative may be selected where substitution is allowed by the customer during checkout.",
        ],
      },
      {
        heading: "Amendment of the Terms and Conditions",
        text: [
          "We may change these Terms and Conditions at any time without prior notice. Continued use of the website or app after changes means that you accept the revised terms.",
        ],
      },
    ],
  },
  {
    title: "Governing Law and Jurisdiction",
    blocks: [
      {
        text: [
          "These Terms and Conditions are construed in accordance with the federal laws of the United Arab Emirates and the local laws and regulations of the Emirate of Dubai.",
          "The courts of Dubai have exclusive jurisdiction in proceedings arising out of these Terms and Conditions.",
        ],
      },
    ],
  },
  {
    title: "Copyright & Trademark",
    blocks: [
      {
        text: [
          "Unless otherwise noted, website content, trademarks, trade dress, and intellectual property are owned, controlled, or licensed by RGHT NOW LLC-FZ, its affiliates, suppliers, merchants, or licensors.",
        ],
      },
      {
        heading: "Objectionable Material",
        text: [
          "You understand that by using the website or app you may encounter content that some users may consider offensive or objectionable, and you use the service at your own risk.",
        ],
      },
      {
        heading: "Indemnity",
        text: [
          "You agree to defend, indemnify, and hold us and our affiliates harmless from claims, damages, costs, and expenses arising from your use of the website or app or breach of these terms.",
        ],
      },
      {
        heading: "Termination",
        text: [
          "These Terms and Conditions remain effective until terminated. You may terminate them by discontinuing use of the website or app. We may terminate access immediately without liability.",
        ],
      },
    ],
  },
  {
    title: "Limitation of Liability",
    blocks: [
      {
        text: [
          "Rght NOW L.L.C, its affiliates, employees, directors, agents, suppliers, or merchant stores are not liable for indirect, special, incidental, or consequential losses arising from use of, or inability to use, the website or app.",
          "Our total liability for all liabilities arising out of these Terms and Conditions is limited to the value of the product ordered by you.",
        ],
      },
    ],
  },
  {
    title: "Disclaimer",
    blocks: [
      {
        text: [
          "Although we aim to offer the best service possible, delays, interruptions, data errors, product information changes, or service faults may occur.",
          "Product details, ingredients, nutritional guides, and allergy advice may change, so customers should read product labels before use.",
        ],
      },
    ],
  },
  {
    title: "Entire Agreement",
    blocks: [
      {
        text: [
          "If any part of these Terms and Conditions is invalid or unenforceable, the remaining provisions continue in effect.",
          "These Terms and Conditions constitute the entire agreement between you and us with respect to the website, app, and services.",
        ],
      },
    ],
  },
  {
    title: "Privacy Policy",
    blocks: [
      {
        text: [
          "We do not sell or rent your personal information to third parties for marketing purposes without your explicit consent. We use your information as described in the Privacy Policy.",
        ],
      },
    ],
  },
  {
    title: "Refund Policy",
    blocks: [
      {
        text: [
          "Refund decisions are made case by case based on product condition, availability, repairability, delivery status, and applicable merchant or business partner policies.",
          "Approved refunds are processed through the original payment method, subject to applicable bank, card, merchant, or cash-on-delivery procedures.",
        ],
      },
      {
        heading: "Refund Conditions",
        text: [
          "The after-sales service team is the point of contact for exchange, refund, or repair claims. Proof of purchase and original packaging may be required.",
        ],
      },
      {
        heading: "Exchange or Refund",
        text: [
          "Items must generally be returned in original, re-sellable condition within the applicable return period. Certain product categories may be non-returnable unless defective.",
        ],
      },
      {
        heading: "Repairs",
        text: [
          "Items found defective after the applicable return period are subject to supplier, merchant, business partner, and warranty terms as applicable.",
        ],
      },
    ],
  },
];

const TermsAndConditionsPage = () => (
  <div className="legal-page">
    <RghtnowMarketingHeader />
    <main className="legal-shell">
      <div className="container">
        <div className="terms-stack">
          {termsSections.map((section) => (
            <section className="terms-card" key={section.title}>
              <h2>{section.title}</h2>
              {section.blocks.map((block, index) => (
                <React.Fragment key={`${section.title}-${index}`}>
                  {block.heading && <h4>{block.heading}</h4>}
                  {block.text.map((paragraph) => (
                    <p key={paragraph}>{paragraph}</p>
                  ))}
                </React.Fragment>
              ))}
            </section>
          ))}
        </div>
      </div>
    </main>
    <a className="legal-whatsapp" href="https://wa.me/971504781269" target="_blank" rel="noreferrer" aria-label="WhatsApp">
      <i className="ph-fill ph-whatsapp-logo" />
    </a>
    <RghtnowMarketingFooter />
  </div>
);

export default TermsAndConditionsPage;
